<form [formGroup]="form">
  <h3 class="my-4">{{'lang.address.information:' | translate}}</h3>
  <div class="row">
    <div class="col-6">
      <div class="form-group validateMe">
        <label for="Street" class="form-label">{{'lang.address.street' | translate}}<span class="red" *ngIf="!noValidation">*</span>
        </label>
        <input type="text" id="Street" class="form-control" formControlName="AddressStreet">
        <div *ngIf="AddressStreet.touched && AddressStreet.errors?.required"
             class="alert alert-danger">{{'lang.address.streetWarning' | translate}}</div>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group validateMe">
        <label for="Street2" class="form-label">{{'lang.address.street2' | translate}}</label>
        <input type="text" id="Street2" class="form-control" formControlName="AddressStreet2">
      </div>
    </div>
    <div class="col-4">
      <div class="form-group validateMe">
        <label for="Zip" class="form-label">{{'lang.address.zip' | translate}}<span class="red" *ngIf="!noValidation">*</span></label>
        <input type="text" id="Zip" class="form-control" formControlName="AddressZip">
        <div *ngIf="AddressZip.touched && AddressZip.errors?.required"
             class="alert alert-danger">{{'lang.address.zipWarning' | translate}}</div>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group validateMe">
        <label class="form-label" for="City">{{'lang.address.city' | translate}}<span class="red" *ngIf="!noValidation">*</span></label>
        <input type="text" id="City" class="form-control" formControlName="AddressCity">
        <div *ngIf="AddressCity.touched && AddressCity.errors?.required"
             class="alert alert-danger">{{'lang.address.cityWarning' | translate}}</div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="form-group validateMe">
        <label class="form-label" for="Borough">{{'lang.address.borough' | translate}}</label>
        <input type="text" id="Borough" class="form-control" formControlName="AddressBorough">
        <div *ngIf="AddressBorough.touched && AddressBorough.errors?.required"
             class="alert alert-danger">{{'lang.address.boroughWarning' | translate}}</div>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group validateMe">
        <label class="form-label" for="County">{{'lang.address.county' | translate}}</label>
        <input type="text" id="County" class="form-control" formControlName="AddressCounty">
        <div *ngIf="AddressCounty.touched && AddressCounty.errors?.required"
             class="alert alert-danger">{{'lang.address.countyWarning' | translate}}</div>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group validateMe">
        <label class="form-label" for="State">{{'lang.address.state' | translate}}</label>
        <input type="text" id="State" class="form-control" formControlName="AddressState">
        <div *ngIf="AddressState.touched && AddressState.errors?.required"
             class="alert alert-danger">{{'lang.address.stateWarning' | translate}}</div>
      </div>
    </div>
    <div class="col-6">
      <sb-comp-country-select
        *ngIf="address"
        [noValidation]="noValidation"
        [selectedCountry]="address?.country"
        (countrySelectEmitter)="countryUpdate($event)">
      </sb-comp-country-select>
    </div>
  </div>
  <ng-container *ngIf="!hideCoordinates">
    <hr class="border-dashed">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label class="form-label" for="Latitude">{{'lang.globals.latitude' | translate}}</label>
          <input type="text" id="Latitude" class="form-control" formControlName="Latitude">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="form-label" for="Longitude">{{'lang.globals.longitude' | translate}}</label>
          <input type="text" id="Longitude" class="form-control" formControlName="Longitude">
        </div>
      </div>
      <div class="col-md-4 d-flex align-items-center">
        <sb-button class="w-100" (submitClicked)="previewPosition()"
                   [disabled]="!address?.street || (!address?.zip && !address?.city)"
                   classes="btn-success m-0 w-100">{{'lang.address.coordinates' | translate}}</sb-button>
      </div>
    </div>
  </ng-container>
</form>
